import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { observer } from "mobx-react";
import User from "../stores/userStore";

//page

import Home from "../pages/home";
import Login from "../pages/login";

import Server from "../pages/serverA";
import ServerA from "../pages/serverA";

import Sms from "../pages/sms";

import Location from "../pages/location";
import UserScreen from "../pages/user";
import History from "../pages/history";
import Detail from "../pages/detail";
import Expo from "../pages/expo";
import Corona from "../pages/corona";
import Copy from "../pages/copy/Copy";
import Copy2 from "../pages/copy2";
import Ip from "../pages/ip";
import Calculate from "../pages/calculate";
import Attendance from "../pages/attendance";
import Logininfo from "../pages/logininfo";

const isDev = process.env.NODE_ENV !== "production";

const root = observer(
  class Root extends React.Component {
    constructor(props) {
      super(props);
    }
    render() {
      const user = User.user;

      return (
        <BrowserRouter>
          <Switch>
            <Route path="/" exact component={Auth(Home, user)} />
            <Route path="/login" exact component={Login} />
            <Route path="/server" exact component={Auth(Server, user)} />
            <Route path="/sms" exact component={Auth(Sms, user)} />
            <Route
              path="/location/:locname"
              exact
              component={Auth(Detail, user)}
            />
            <Route path="/location" exact component={Auth(Location, user)} />
            <Route path="/user" exact component={Auth(UserScreen, user)} />
            <Route path="/logininfo" exact component={Logininfo} />
            <Route path="/expo" exact component={Expo} />
            <Route path="/corona" exact component={Auth(Corona, user)} />
            <Route path="/copy" exact component={Copy} />
            <Route path="/copy2" exact component={Copy2} />
            <Route
              path="/attendance"
              exact
              component={Auth(Attendance, user)}
            />
            <Route path="/ip" exact component={Ip} />
            <Route path="/calculate" exact component={Auth(Calculate, user)} />
            <Route
              path="/history/:locname"
              exact
              component={Auth(History, user)}
            />
            <Route
              path="/logout"
              exact
              component={() => {
                User.Logout();
                return <Redirect to="/" />;
              }}
            />
            <Redirect path="*" to="/" />
          </Switch>
        </BrowserRouter>
      );
    }
  }
);

function Auth(component, user) {
  if (user) {
    return component;
  } else {
    if (isDev) {
      //복본테스트용
      return component;
    }
    return Login;
  }
}

export default root;
